import { Component } from '@angular/core';
import { GlobalEMailTemplate } from 'src/modules/enaio/netgen/GlobalEMailTemplate';
import { FrontendField } from 'src/modules/sm-base/netgen/FrontendField';
import { FrontendFieldType } from 'src/modules/sm-base/netgen/FrontendFieldType';
import { FrontendForm } from 'src/modules/sm-base/netgen/FrontendForm';
import { AdminBaseEditComponent } from '../admin-base-edit/admin-base-edit.component';
import { EditGlobalEMailTemplatesComponent } from '../edit-global-email-templates.component/edit-global-email-templates.component';
import { Objects } from 'src/modules/utils/shared/objects';
import { EntityDefinition } from '../../models/entity-definition.model';

@Component({
    selector: 'app-edit-global-email-template',
    templateUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.html',
    styleUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.scss',
    standalone: false
})
export class EditGlobalEMailTemplateComponent extends AdminBaseEditComponent<GlobalEMailTemplate> {
    
    definition = Objects.with(Objects.with(Objects.fromPlain(EntityDefinition<GlobalEMailTemplate>, EditGlobalEMailTemplatesComponent.staticDefinition), "canInsert", this.app.mainConfig.globalEmailTemplatesAllowAdd), "canDelete", this.app.mainConfig.globalEmailTemplatesAllowAdd);
    
    item: GlobalEMailTemplate;

    getForm(): FrontendForm {
        return new FrontendForm([
            new FrontendField("title", "Titel", FrontendFieldType.string, { 
                mandatory: true,
                maxLength: 100,
                enabled: !this.item.isRequired
            }),
            new FrontendField("subject", "Betreff", FrontendFieldType.string, {
                mandatory: true,
                maxLength: 200
            }),
            new FrontendField("body", "Nachrichtentext", FrontendFieldType.textArea, {
                maxLength: 4000,
                fixedHeight: "300px"
            })
        ]); 
    }

}